import { render, staticRenderFns } from "./PromotionStepMenuItem.vue?vue&type=template&id=effde010&scoped=true"
import script from "./PromotionStepMenuItem.vue?vue&type=script&lang=js"
export * from "./PromotionStepMenuItem.vue?vue&type=script&lang=js"
import style0 from "./PromotionStepMenuItem.vue?vue&type=style&index=0&id=effde010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effde010",
  null
  
)

export default component.exports